import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

const ResolvedOrgContext = createContext(null);

export function ResolvedOrgProvider({ value, children }) {
  return <ResolvedOrgContext.Provider value={value || null}>{children}</ResolvedOrgContext.Provider>;
}

export function useResolvedOrgContext() {
  return useContext(ResolvedOrgContext);
}

export function useResolvedOrgSlug(fallback = "") {
  const context = useResolvedOrgContext();
  return context?.orgSlug || fallback || "";
}

export function useResolvedRouteParams() {
  const params = useParams();
  const context = useResolvedOrgContext();
  return {
    ...params,
    ...(context?.readOnlyWebsitePreview ? context.previewRouteParams : {}),
    orgSlug: params.orgSlug || context?.orgSlug || "",
    resolvedOrgContext: context,
  };
}
